module.exports = __webpack_public_path__ + "static/media/chill-spins-150x150-transparent.97a5dcda.png";